import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition, ITreeItem } from '../../../models';
import { IGroupService } from '../../../services';
import { seriesAdded } from '../../../common';

class GroupSelectionController implements angular.IComponentController {
    displayed: ITreeItem[];
    filtered: ITreeItem[];
    format: any;
    groups: ITreeItem[];
    isLoading: boolean;
    loadingMessage: string;
    searchEnable: any;

    static $inject = ['$rootScope', 'groupService'];

    constructor(private _$rootScope: angular.IRootScopeService,
        private _groupService: IGroupService) {
    }

    $onInit() {
        let groups = [];
        this._groupService.getAllAsTree()
            .then(data => {
                groups = data.filter(d => d.depth >= 1);
                return this._groupService.getPaths(groups.map(d => d.guid));
            })
            .then(data => {
                groups.forEach(g => {
                    const found = _.find(data, d => d.guid === g.guid);
                    if (found) {
                        g.path = found.path;
                    }
                });
                this.groups = groups;
            });


        this.format = {
            name: f => this.buildArray(f, [], 'name').join(),
            group: f => this.buildArray(f, [], 'group').join(),
            comment: f => this.buildArray(f, [], 'shortComment').join(),
            type: f => this.buildArray(f, [], 'type').join(),
            tag: f => this.buildArray(f, [], 'type').join()
        };
        this.searchEnable = { type: true };
    }

    private buildArray(f: ITreeItem, currentList: string[], property: string): string[] {
        currentList.push(f[property]);
        if (f.children) {
            f.children.forEach(c => this.buildArray(c, currentList, property));
        }
        return currentList;
    }

    add(group: any) {
        this._$rootScope.$broadcast(seriesAdded, group);
    }
}

export const wtGroupSelection: ComponentDefinition = {
    componentId: 'wtGroupSelection',
    controller: GroupSelectionController,
    template: require('./groupSelection.component.html'),
    controllerAs: 'vm',
    bindings: {

    }
};
